exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdl-dialog{text-align:left;width:50%;min-width:280px}.mdl-dialog__title{font-size:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-613d6f60!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SectionMyAdventures.vue
// module id = 230
// module chunks = 0